import { render } from "./NotFound.vue?vue&type=template&id=0c743eaa&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=0c743eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c743eaa"]])

export default __exports__